module.exports = __webpack_public_path__ + "static/media/M-Cure LX.3bbe5d44.jpg";